// Override with REACT_APP_API_URL (e.g. http://127.0.0.1:8000) to point a local
// build at a local backend without editing this file.
export const baseUrl =
  process.env.REACT_APP_API_URL || "https://planque-backend.onrender.com";

export default baseUrl;
